const pad = (n) => String(n).padStart(2, "0");
export const isoDay = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const presets = () => {
  const today = new Date();
  const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
  const sunday = new Date(today); sunday.setDate(today.getDate() + ((7 - today.getDay()) % 7));
  return [
    { key: "none", label: "Siempre", starts_on: "", ends_on: "" },
    { key: "today", label: "Solo hoy", starts_on: isoDay(today), ends_on: isoDay(today) },
    { key: "tomorrow", label: "Solo mañana", starts_on: isoDay(tomorrow), ends_on: isoDay(tomorrow) },
    { key: "week", label: "Esta semana", starts_on: isoDay(today), ends_on: isoDay(sunday) },
  ];
};

export const formatDay = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("es-ES", { weekday: "short", day: "numeric", month: "short" });
};

export const rangeLabel = (n) => {
  if (!n.starts_on && !n.ends_on) return "Sin fecha de fin";
  if (n.starts_on && n.starts_on === n.ends_on) return formatDay(n.starts_on);
  if (n.starts_on && n.ends_on) return `${formatDay(n.starts_on)} → ${formatDay(n.ends_on)}`;
  if (n.starts_on) return `Desde ${formatDay(n.starts_on)}`;
  return `Hasta ${formatDay(n.ends_on)}`;
};

export const errText = (e, fb) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : fb);
